/**
 * ```sh
 * npm install @ceramicnetwork/rpc-window
 * ```
 *
 * @module rpc-window
 */ import { createNamespaceClient, createNamespaceServer } from '@ceramicnetwork/rpc-postmessage';
import { createPostMessageTransport } from '@ceramicnetwork/transport-postmessage';
const DEFAULT_OPTIONS = {
    onInvalidInput: (_input, _error)=>{
    // Silence warnings of invalid messages, such as message events sent by third-parties
    },
    // Client requests will be sent without origin restriction
    postMessageArguments: [
        '*'
    ]
};
export function createClient(namespace, target = window, options = DEFAULT_OPTIONS) {
    const transport = createPostMessageTransport(window, target, options);
    return createNamespaceClient(transport, namespace, options);
}
export function createServer(namespace, methods, target = window) {
    return createNamespaceServer({
        methods,
        namespace,
        target
    });
}
